import { IBudgetActionAddEditRequest } from '../../../../model/sge/budget-action/request/budget-action-add-edit-request';
import { IBudgetActionResponse } from '../../../../model/sge/budget-action/response/budget-action-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export const BUDGET_ACTION_TYPES = [
    { id: 1, label: 'Projeto' },
    { id: 2, label: 'Atividade' },
];

export function getBudgetActionTypeLabel(actionType?: number): string {
    return BUDGET_ACTION_TYPES.find((t) => t.id === actionType)?.label ?? (actionType ? String(actionType) : '');
}

// O formulário guarda a unidade orçamentária apenas para filtrar os programas; ela não vai para a API
export type BudgetActionForm = IBudgetActionAddEditRequest & { budgetUnitId?: number };

export type BudgetActionField = 'budgetUnitId' | 'budgetProgramId' | 'actionType' | 'code' | 'name';

export function toBudgetActionForm(data?: IBudgetActionResponse, budgetUnitId?: number): BudgetActionForm {
    if (!data) return {};
    return { budgetUnitId, budgetProgramId: data.budgetProgramId, actionType: data.actionType, code: data.code, name: data.name };
}

export function validateBudgetAction(form: BudgetActionForm): ValidationErrors<BudgetActionField> {
    const errors: ValidationErrors<BudgetActionField> = {};
    if (isEmptyId(form.budgetUnitId)) errors.budgetUnitId = 'Unidade orçamentária é obrigatória';
    if (isEmptyId(form.budgetProgramId)) errors.budgetProgramId = 'Programa orçamentário é obrigatório';
    if (isEmptyId(form.actionType)) errors.actionType = 'Tipo é obrigatório';
    if (isBlank(form.code)) errors.code = 'Código é obrigatório';
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    return errors;
}

export function toBudgetActionRequest(form: BudgetActionForm): IBudgetActionAddEditRequest {
    return { budgetProgramId: form.budgetProgramId, actionType: form.actionType, code: form.code?.trim(), name: form.name?.trim() };
}
